import styled from '@emotion/styled';

import { typographyVariantStyles } from '../../typography-variants';

// The wheel columns divide the width between them, so two of them drift apart on a wide surface
// the way three never do. Capping the group keeps the hour and minute reading as one clock.
export const StyledContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: 200,
  marginInline: 'auto',
});

export const StyledSeparator = styled('span')(({ theme }) => ({
  ...typographyVariantStyles.body2,
  alignSelf: 'center',
  color: theme.colors.text.tertiary,
  userSelect: 'none',
}));
